import { FadeUp, Eyebrow } from "./Reveal";

const STAGES = [
  {
    num: "01",
    name: "Foundations",
    period: "Year 1",
    body: "Lease on Māori freehold land at Aotea, licensing and regulatory advice, governance and quality systems established.",
  },
  {
    num: "02",
    name: "Research & Cultivars",
    period: "Years 1–2",
    body: "Licence application lodged. Site trials begin — documenting cultivars suited to Kāwhia's volcanic soils.",
  },
  {
    num: "03",
    name: "Commercial Cultivation",
    period: "Years 2–3",
    body: "Licence granted, cultivation infrastructure built, first supply agreements with licensed manufacturers signed.",
  },
  {
    num: "04",
    name: "Growth & Distribution",
    period: "Year 3 +",
    body: "Scale-up of production, deeper research partnerships, and pathways toward manufacture and export markets.",
  },
];

export const Roadmap = () => (
  <section id="roadmap" className="relative bg-[#F3EFE6] py-28 sm:py-40" data-testid="roadmap-section">
    <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
      <FadeUp>
        <Eyebrow>03 — The Plan</Eyebrow>
      </FadeUp>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mt-6 mb-16 sm:mb-24">
        <FadeUp delay={0.1}>
          <h2 className="font-serif-brand text-4xl sm:text-5xl lg:text-6xl text-[#121512] leading-[1.05] tracking-tight max-w-2xl">
            A staged, <span className="italic text-[#1E3A2B]">low-risk</span> path to market.
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="text-sm sm:text-base text-[#5A665D] max-w-sm leading-relaxed">
            Milestone-based funding released against progress — structured, transparent, and controlled.
          </p>
        </FadeUp>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-8 gap-y-14">
        {STAGES.map((s, i) => (
          <FadeUp key={s.num} delay={i * 0.12}>
            <div className="group relative border-t-2 border-[#1E3A2B]/20 pt-7 transition-colors duration-500 hover:border-[#D4A359]" data-testid={`roadmap-stage-${s.num}`}>
              <p className="font-serif-brand text-6xl sm:text-7xl text-[#1E3A2B]/15 leading-none transition-colors duration-500 group-hover:text-[#D4A359]/60">
                {s.num}
              </p>
              <p className="font-mono-brand text-[10px] uppercase tracking-[0.26em] text-[#3B5E4A] mt-6">{s.period}</p>
              <h3 className="font-serif-brand text-2xl sm:text-[1.7rem] text-[#121512] mt-2.5">{s.name}</h3>
              <p className="text-sm text-[#5A665D] leading-relaxed mt-3.5">{s.body}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
